export function parseJsonIfValid(value: any) {
    try {
        if (typeof value === 'string') {
            const res = JSON.parse(value);
            return res;
        }
        return value;
    } catch (e) {
        return {};
    }
}

export function isObject(value: any): boolean {
    return Object.prototype.toString.call(value) === '[object Object]';
}
export function deepMerge(...objects: any[]) {
    return objects.reduce((result, current) => {
        if (Array.isArray(current)) {
            throw new TypeError('Arguments provided to deepMerge must be objects, not arrays.');
        }
        Object.keys(current).forEach((key) => {
            if (['__proto__', 'constructor', 'prototype'].includes(key)) {
                return;
            }
            if (Array.isArray(result[key]) && Array.isArray(current[key])) {
                result[key] = Array.from(new Set((result[key] as unknown[]).concat(current[key])));
            } else if (isObject(result[key]) && isObject(current[key])) {
                result[key] = deepMerge(result[key], current[key]);
            } else {
                result[key] = current[key];
            }
        });
        return result;
    }, {});
}
function generateCachedTimestamp() {
    let timestamp: string = '';

    return function () {
        if (!timestamp) {
            timestamp = Date.now().toString();
        }
        return timestamp;
    };
}
export const getCachedTimestamp = generateCachedTimestamp();

export function generateTimestampedUrl(baseUrl?: string) {
    if (!baseUrl) {
        return '';
    }
    const url = new URL(baseUrl);
    const params = new URLSearchParams(url.search);
    params.append('ts', getCachedTimestamp());
    url.search = params.toString();
    return url.href;
}
